/* src/app/component/posts/posts.component.css */
/*# sourceMappingURL=posts.component.css.map */
